/**
 * Feature Flags Configuration
 * 
 * Control feature availability at the code level.
 * Set to true to enable, false to disable.
 */

export const FEATURE_FLAGS = {
  /**
   * TENT_WEEKEND_ONLY_RESTRICTION
   * 
   * When enabled: Tent rooms are only available on Fridays, Saturdays, and Sundays
   * When disabled: Tent rooms are available on all days of the week
   * 
   * Default: false (restriction disabled - tents available all days)
   */
  TENT_WEEKEND_ONLY_RESTRICTION: false,
};
